/** Shared /new vs /new/ helpers — no DOM. Vite config and the SPA both import this. */

export const NEW_VIEWER_BASENAME = '/new';
export const NEW_VIEWER_BASENAME_SLASH = `${NEW_VIEWER_BASENAME}/`;
export const NEW_VIEWER_LOGIN_HREF = '/new/login';

/**
 * Vite `base: '/new/'` serves the SPA at `/new/` and answers bare `/new` with
 * a plain-text error ("did you mean to visit /new/ instead?"). Map `/new` →
 * `/new/` and keep query/hash. Every other path is left alone.
 */
export const redirectBareNewBase = (url: string): string | null => {
  if (!url) return null;
  const hashIndex = url.indexOf('#');
  const withoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
  const q = withoutHash.indexOf('?');
  const path = q === -1 ? withoutHash : withoutHash.slice(0, q);
  if (path !== NEW_VIEWER_BASENAME) return null;
  const query = q === -1 ? '' : withoutHash.slice(q);
  return `${NEW_VIEWER_BASENAME_SLASH}${query}${hash}`;
};
